import React from 'react';
import * as toolSelectors from '../../../../../selectors/tools';
import { useSelector } from 'react-redux';

import {
  ResultsColumn,
  ResultsColumnHeader,
  Row,
  HeaderRow,
  SubTitleText,
  Spreadsheet,
} from '../../DTInfoWidget.styles';

const DTRbiRutrEventsInfoWidget = () => {
  const rbiRutrEventsInfo = useSelector(toolSelectors.getRbiRutrEventsInfo);

  return (
    <>
      <Spreadsheet className="fs-block">
        <HeaderRow>
          <ResultsColumnHeader>CREATED AT</ResultsColumnHeader>
          <ResultsColumnHeader>TYPE</ResultsColumnHeader>
          <ResultsColumnHeader>PRIZE ID</ResultsColumnHeader>
          <ResultsColumnHeader>EVENT ID</ResultsColumnHeader>
        </HeaderRow>
        {rbiRutrEventsInfo.length ? (
          rbiRutrEventsInfo.map((event) => (
            <Row key={event.createdAt}>
              <ResultsColumn>{event.createdAt}</ResultsColumn>
              <ResultsColumn>{event.type}</ResultsColumn>
              <ResultsColumn>{event.prizeId}</ResultsColumn>
              <ResultsColumn>{event.eventId}</ResultsColumn>
            </Row>
          ))
        ) : (
          <SubTitleText style={{ marginTop: '15px' }}>No events found</SubTitleText>
        )}
      </Spreadsheet>
    </>
  );
};
export default DTRbiRutrEventsInfoWidget;
